import PropTypes from "prop-types";
import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "~/material-dashboard/components/Card/Card.jsx";
import CardBody from "~/material-dashboard/components/Card/CardBody.jsx";
import Button from "~/material-dashboard/components/CustomButtons/Button.jsx";
import GridContainer from "~/material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "~/material-dashboard/components/Grid/GridItem.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import { trackVisitProductSelected } from "../utils/analytics.js";

import imgOnePack from "~assets/images/visits/one-pack.png";
import imgTwoPack from "~assets/images/visits/two-pack.png";

import {
  getVisitID,
  getVisitProduct,
  isFollowUpVisit,
  setConsultationTypeOrderItem,
  setVisitProduct,
} from "~/visits/utils/visitCookies";

import {
  COLOR_KICK_BLUE,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  ORDER_TYPE_PROP_1_PACK_FLAVORED,
  ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
  ORDER_TYPE_PROP_2_PACK_FLAVORED,
  ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP,
  PRICE_PROP_1_PACK_FLAVORED,
  PRICE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
  PRICE_PROP_2_PACK_FLAVORED,
  PRICE_PROP_2_PACK_FLAVORED_FOLLOW_UP,
} from "~/shared/sharedConstants.js";

import { kickBlue, kickNavy, kickRed } from "~/shared/styles/baseStyles";

import { getBBProductDetails } from "./payment/paymentHelpers.js";

class SelectNumPacksFlavored extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);
    const checkoutSessionID = queryParams.get("checkoutSessionID");
    if (!checkoutSessionID) {
      window.location.href = "/me/portal";
    }

    this.state = {
      consultationType: this.props.match.params.consultationType,
      checkoutSessionID,
      selectedProduct: getVisitProduct(checkoutSessionID) || "",
      showError: false,
    };

    if (!getVisitID(checkoutSessionID)) {
      window.location.href = "/me/portal";
    }
  }

  handleSelection = (selectedProduct) => {
    let modifiedProduct = selectedProduct;
    const { checkoutSessionID } = this.state;

    if (isFollowUpVisit(checkoutSessionID)) {
      switch (selectedProduct) {
        case ORDER_TYPE_PROP_2_PACK_FLAVORED:
          modifiedProduct = ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP;
          break;

        case ORDER_TYPE_PROP_1_PACK_FLAVORED:
          modifiedProduct = ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP;
          break;
      }
    }

    this.setState({ selectedProduct: modifiedProduct, showError: false });
    setVisitProduct(modifiedProduct, checkoutSessionID);
    setConsultationTypeOrderItem(
      this.state.consultationType,
      modifiedProduct,
      checkoutSessionID,
    );
  };

  nextQuestion = () => {
    const validProducts = [
      ORDER_TYPE_PROP_1_PACK_FLAVORED,
      ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
      ORDER_TYPE_PROP_2_PACK_FLAVORED,
      ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP,
    ];

    if (!validProducts.includes(this.state.selectedProduct)) {
      this.setState({ showError: "true" });
      return;
    }

    setConsultationTypeOrderItem(
      this.state.consultationType,
      this.state.selectedProduct,
      this.state.checkoutSessionID,
    );

    this.props.history.push(
      `/visits/${this.state.consultationType}/choose-flavor?checkoutSessionID=${this.state.checkoutSessionID}`,
    );
    window.scrollTo(0, 0);
  };

  isSelected = (selectedProduct) => {
    return this.state.selectedProduct === selectedProduct;
  };

  getPrice = (orderType) => {
    const { consultationType } = this.state;
    const isFollowUp =
      consultationType !== CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY;

    switch (orderType) {
      case ORDER_TYPE_PROP_2_PACK_FLAVORED:
        return isFollowUp
          ? PRICE_PROP_2_PACK_FLAVORED_FOLLOW_UP
          : PRICE_PROP_2_PACK_FLAVORED;
      case ORDER_TYPE_PROP_1_PACK_FLAVORED:
        return isFollowUp
          ? PRICE_PROP_1_PACK_FLAVORED_FOLLOW_UP
          : PRICE_PROP_1_PACK_FLAVORED;
      default:
        return 0;
    }
  };

  formatPrice = (price) => {
    return `$${price}`;
  };

  render() {
    const { classes } = this.props;

    const { bbName } = getBBProductDetails(this.state.checkoutSessionID);

    return (
      <div
        className={classes.container}
        style={{ backgroundColor: COLOR_KICK_BLUE }}
      >
        <GridContainer justifyContent="center">
          <GridItem xs={10} sm={10} md={8}>
            <h3
              style={{
                color: "#FFFFFF",
                fontFamily: "Spectral-SemiBold",
                fontSize: "32px",
                marginTop: "40px",
              }}
            >
              How many packs of flavored beta-blockers would you like?
            </h3>
            <p
              style={{
                color: "#FFFFFF",
                fontFamily: "BasisGrotesquePro-Regular",
                fontSize: "18px",
                lineHeight: "26px",
              }}
            >
              Your preference will be shared with your doctor to determine the
              best treatment plan.
              <br />
            </p>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card className={classes.cardConsultation}>
              <CardBody
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 2px",
                }}
              >
                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    overflow: "hidden",
                    backgroundColor:
                      this.isSelected(ORDER_TYPE_PROP_2_PACK_FLAVORED) ||
                      this.isSelected(ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP)
                        ? "#fff7e5"
                        : "",
                  }}
                  onClick={() =>
                    this.handleSelection(ORDER_TYPE_PROP_2_PACK_FLAVORED)
                  }
                >
                  <img
                    className="imgTwoPack"
                    src={imgTwoPack}
                    style={{
                      height: "fit-content",
                      position: "relative",
                      marginBottom: "10px",
                    }}
                    alt={`Double Pack ${bbName} (48 troches)`}
                  />
                  <div className={classes.selectBBProductTwoPackWrapper}>
                    <h4
                      className={classes.selectBBProductImageTitle}
                      style={{
                        marginBottom: 0,
                        color: kickBlue,
                        fontWeight: "bold",
                      }}
                    >
                      Two Packs {bbName} (48 Troches)
                    </h4>
                    <p
                      style={{
                        fontSize: "16px",
                        color: kickRed,
                        fontWeight:
                          this.isSelected(ORDER_TYPE_PROP_2_PACK_FLAVORED) ||
                          this.isSelected(
                            ORDER_TYPE_PROP_2_PACK_FLAVORED_FOLLOW_UP,
                          )
                            ? "bold"
                            : "",
                      }}
                    >
                      {this.formatPrice(
                        this.getPrice(ORDER_TYPE_PROP_2_PACK_FLAVORED),
                      )}{" "}
                      - Medication with FREE Shipping
                      <br />
                      <span
                        style={{
                          fontSize: "15px",
                          color: kickNavy,
                        }}
                      >
                        {" "}
                        Most Popular Option
                      </span>
                    </p>

                    <ul
                      style={{
                        fontSize: "18px",
                        color: kickNavy,
                        lineHeight: "140%",
                      }}
                    >
                      <li style={{ paddingBottom: "2px" }}>
                        Always be prepared with a pack at home and another at
                        work.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Two-pack refills without needing a new prescription.
                      </li>
                      <li style={{ paddingBottom: "2px" }}>
                        Your order lasts longer, so you can refill less often.
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    height: "1px",
                    margin: "0 100px",
                    backgroundColor: COLOR_KICK_BLUE,
                  }}
                />

                <div
                  className={classes.selectBBProductWrapper}
                  style={{
                    backgroundColor:
                      this.isSelected(ORDER_TYPE_PROP_1_PACK_FLAVORED) ||
                      this.isSelected(ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP)
                        ? "#fff7e5"
                        : "",
                  }}
                  onClick={() =>
                    this.handleSelection(ORDER_TYPE_PROP_1_PACK_FLAVORED)
                  }
                >
                  <img
                    src={imgOnePack}
                    style={{
                      height: "fit-content",
                      marginBottom: "10px",
                      position: "relative",
                    }}
                    alt={`Single Pack ${bbName} Troches`}
                  />
                  <h4
                    className={classes.selectBBProductImageTitleLower}
                    style={{
                      fontWeight:
                        this.isSelected(ORDER_TYPE_PROP_1_PACK_FLAVORED) ||
                        this.isSelected(
                          ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
                        )
                          ? "bold"
                          : "",
                    }}
                  >
                    One Pack {bbName} (24 troches)
                    <br />
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight:
                          this.isSelected(ORDER_TYPE_PROP_1_PACK_FLAVORED) ||
                          this.isSelected(
                            ORDER_TYPE_PROP_1_PACK_FLAVORED_FOLLOW_UP,
                          )
                            ? "bold"
                            : "",
                      }}
                    >
                      {this.formatPrice(
                        this.getPrice(ORDER_TYPE_PROP_1_PACK_FLAVORED),
                      )}{" "}
                      — Medication with FREE Shipping
                    </p>
                  </h4>
                </div>
              </CardBody>
            </Card>
            <div style={{ color: "red", margin: "20px auto 6px auto" }}>
              <p style={{ textAlign: "center" }}>
                {this.state.showError ? "Please select an option above" : ""}
              </p>
            </div>
            <Button
              onClick={() => {
                trackVisitProductSelected(
                  getVisitID(this.state.checkoutSessionID),
                  this.state.selectedProduct,
                );
                this.nextQuestion();
              }}
              style={{
                display: "block",
                backgroundColor: "#F25930",
                margin: "4px auto 30px auto",
                width: "300px",
                fontSize: "18px",
                fontWeight: "medium",
                textTransform: "unset",
              }}
            >
              Continue
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  componentDidMount() {
    this.visitIDCheckPoller = setInterval(() => {
      if (!getVisitID(this.state.checkoutSessionID)) {
        window.location.href = "/me/portal";
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.visitIDCheckPoller);
  }
}

SelectNumPacksFlavored.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(SelectNumPacksFlavored);
